import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { classes, style } from "typestyle";

export interface IconProps {
  icon: IconDefinition;
  color?: string;
  className?: string;
}
export const Icon: FC<IconProps> = ({ icon, color, className }) => {
  return (
    <FontAwesomeIcon
      icon={icon as FontAwesomeIconProps["icon"]}
      color={color}
      className={classes(style({ height: "17px" }), className)}
      data-testid="icon"
    />
  );
};
